<mat-card class="top-card mat-elevation-z0">
  <div class="strong">
    Pijltjes{{ multiple ? ' bord #' + (index + 1) : '' }}
  </div>
  <div class="upper-space d-flex">
    <div class="configuration-container">
      <div *ngIf="ipBoardPlacement?.arrows.amountArrowsLeft != null">
        <span>Aantal links: </span>
        <span class="strong">{{
          ipBoardPlacement.arrows.amountArrowsLeft
        }}</span>
      </div>
      <div *ngIf="ipBoardPlacement?.arrows.amountArrowsRight != null">
        <span>Aantal rechts: </span>
        <span class="strong">{{
          ipBoardPlacement.arrows.amountArrowsRight
        }}</span>
      </div>
      <div *ngIf="ipBoardPlacement?.arrows.arrowsDesign?.length > 0">
        <span class="preserve-line-break display-contents">
          <span>Info design: </span>
          <span class="strong inline-flex">{{
            ipBoardPlacement.arrows.arrowsDesign
          }}</span>
        </span>
      </div>
      <div *ngIf="ipBoardPlacement?.arrows.arrowsLocation?.length > 0">
        <span class="preserve-line-break display-contents">
          <span>Info locatie: </span>
          <span class="strong inline-flex">{{
            ipBoardPlacement.arrows.arrowsLocation
          }}</span>
        </span>
      </div>
    </div>
    <div class="example-container">
      <div class="design-images">
        <ng-container *ngFor="let asset of ipBoard.productAssets">
          <div
            *ngIf="
              !asset.archived &&
              asset.formSection === 'arrowsDesign' &&
              isImage(asset.asset)
            "
          >
            <a
              class="click-link"
              href="/api/assets/{{ asset.asset.uuid }}"
              data-lightbox="arrows-images"
            >
              <img
                class="design-image"
                src="/api/assets/{{ asset.asset.uuid }}"
              />
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</mat-card>
